export interface JwtPayload {
  exp?: number;
  iat?: number;
  email?: string;
  upn?: string;
  [key: string]: unknown;
}

export const decodeJwt = (token: string): JwtPayload | null => {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;
    const base64Url = parts[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join("")
    );
    const payload = JSON.parse(json) as JwtPayload;
    const email = payload.email ?? payload.upn ?? undefined;
    return email ? {...payload, email} : payload;
  } catch {
    return null;
  }
};

export const isJwtExpired = (payload: JwtPayload | null): boolean => {
  if (!payload?.exp) return false;
  return Date.now() >= payload.exp * 1000;
};
